// Main application entry point
// This file controls the exact order of execution



// 3. Then: UI snippet components used across site
import './snippets/blocks.js';
import './snippets/nav-main.js';
import './utils/video-playback.js';
import './snippets/gallery.js';
import './snippets/newsletter.js';
import { setupYouTubeOverlays } from './snippets/youtube.js';

document.addEventListener('DOMContentLoaded', () => {
  setupYouTubeOverlays(); // Use default selector for overlays
});